import React from "react";
import Week from "./components/Week.js";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Week />
    </div>
  );
}

export default App;
